import styles from './styles.module.css';
import React from 'react';

const AppMessage = ({ Message, RequareMessageforChangeBg }) => {
  return (
    <div
      className={
        Message ? styles.server_message_on : styles.server_message_under
      }
    >
      <div
        style={{
          backgroundColor: Message == RequareMessageforChangeBg && 'green',
        }}
        className={
          Message
            ? `${styles.server_message_child_show} mainBg`
            : styles.server_message_child_hide
        }
      >
        <p
          className={
            Message
              ? `${styles.server_message_child_para_show} mainBg`
              : styles.server_message_child_para_hide
          }
        >
          {Message}
        </p>
      </div>
    </div>
  );
};

export default AppMessage;
